import { Vue, Options } from "vue-class-component";
import { ReadingData } from "../../services";
import monitorBloc from "../../services/bloc";
import { Watch } from "vue-property-decorator";

@Options({
  props: {
    equipment: Object,
  },
})
export class BaseStatusComponent extends Vue {
  equipment: any;
  
  status(last_reading: number, diff = 60) {
    return monitorBloc.isActive(last_reading, diff);
  }
}
